import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { FiscalProfilePage } from '@/features/fiscal-profile/components/fiscal-profile-page'

export const Route = createFileRoute('/_app/account/fiscal')({
  component: FiscalPage,
})

function FiscalPage(): JSX.Element {
  return <FiscalProfilePage />
}
